import { useExperiencesContext } from '../../../experiences/Experiences';

export const useFacetSearchData = () => {
  const { isLeftNavHeaderFlagOn } = useExperiencesContext();

  return {
    isLeftNavHeaderFlagOn,
  };
};
